'use strict';

import {
  GET_HARDWARE_PRD_INFO,
  UPDATE_HARDWARE_DATA,
  UPDATE_REQUEST_STATUS,
  GET_MODULE_LIST,
} from '../actions/hardware';

const defVal = {
  pIdDetail: {},
  hardwareData: {},
  moduleList: [],
  requestStatus: 'noRequest',
};

export default (state = defVal, action) => {
  switch (action.type) {
    case UPDATE_REQUEST_STATUS:
      return Object.assign({}, state, {
        requestStatus: action.requestStatus,
      });
    case UPDATE_HARDWARE_DATA:
      return Object.assign({}, state, {
        hardwareData: action.hardwareData,
      });
    case GET_HARDWARE_PRD_INFO:
      return Object.assign({}, state, {
        pIdDetail: action.pIdDetail,
      });
    case GET_MODULE_LIST:
      return Object.assign({}, state, {
        moduleList: action.moduleList,
      });
    default:
      return state;
  }
};
